export { default } from "./Placeholder";
